// PATH: src/components/modules/devtools/components/ChangesPreviewDiffDialog.js

import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

/**
 * ChangesPreviewDiffDialog
 *
 * Small, focused component extracted from ChangesPanel.
 * Keeps the parent panel clean while preserving the existing UI/behaviour.
 */
const ChangesPreviewDiffDialog = ({
  open,
  onClose,
  loading,
  error,
  data,
}) => {
  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Preview diff</DialogTitle>
      <DialogContent dividers>
        {loading && (
          <Box
            sx={{
              py: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={24} />
          </Box>
        )}

        {!loading && !!error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}

        {!loading && !error && data && (
          <Box
            sx={{
              mt: 1,
              fontFamily: "monospace",
              whiteSpace: "pre-wrap",
              fontSize: 12,
              maxHeight: 500,
              overflowY: "auto",
            }}
          >
            {data.diff_text || "(no diff text stored)"}
          </Box>
        )}

        {!loading && !error && !data && (
          <Typography variant="body2" color="text.secondary">
            No diff data available.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangesPreviewDiffDialog;
